import { GridDataTableColumn } from "@src/components/global/v1/GridBuilder/GridDataTable/GridDataTableColumn";

/*
 any field that is nullable should have addEmptyFilters: true
*/


export const columns: GridDataTableColumn[] = [
  {
    Header: "",
    accessor: "id",
    type: "number",
    width: 56,
    minWidth: 56,
    maxWidth: 56,
    linkColumn: true,
    linkUrl: "/crm/admin/client/all/{value}",
    linkIcon: "edit",
    linkShowValue: false,
    disableResizing: true,
    disableSortBy: true,
  },
  {
    Header: "Name",
    accessor: "name",
    width: 300,
    ellipsisCell: true,
  },
  {
    Header: "Alias",
    accessor: "alias",
    addEmptyFilters: true,
  },
  {
    Header: "Code",
    accessor: "code",
  },
  {
    Header: "Created Date",
    accessor: "createdDate",
    type: "date",
    width: 169,
  },
  {
    Header: "Created By",
    accessor: "createdBy",
    width: 140,
    linkColumn: true,
    linkUrl: "/crm/contact/{value}",
    linkOpenWindow: true
  },
  {
    Header: "Updated Date",
    accessor: "updatedDate",
    type: "date",
    width: 169,
  },
  {
    Header: "Updated By",
    accessor: "updatedBy",
    width: 140,
    linkColumn: true,
    linkUrl: "/crm/contact/{value}",
    linkOpenWindow: true
  },
];
